var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_1383",
    transform: "scale(0.05)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_1383",
    width: 20,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAARBJREFUOE/tlCFPw1AUhc+9bRM0sgkCjcBgCP8Ax5aQ+b7bGgQJf6B/Yap9r1Ukc5tCYPgBS1AzU7OoLQGH6NKSki6BhY0OniHh+fPdk3vOfQTLjyzz0AqolDonoisAhwBcACUzX2qtJ+uGvgWKyAWAEfB5eFVVp3mej3cGKqUeiehkXfhjoIi8AtirgUR0VxRF4Hle5fv+SxzHy50dikgtchphP8uy621BbtxhEARnzHwAYACAG8g9gNvG7YMxZtHaoYgMAXQ3uWHmI6311BrQdd39JEmeWwPDMLypkwTQ+VCZGYAJES2NMb2v3LfpoZ1QVtOtpfwP/P2l/J0dRlF0XJble18dx5mnafq07XN4A8XmcRWwQQheAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebook);
export default __webpack_public_path__ + "static/media/footer_facebook.820ed2bba214e5c9530876f89de7e076.svg";
export { ForwardRef as ReactComponent };